module.exports = __webpack_public_path__ + "img/newicon6click.af485d7d.svg";